export class KernelEventBus {
    #durableSequences = new Set();
    #onSubscriberError;
    #subscribers = new Map();
    constructor(options = {}) {
        this.#onSubscriberError = options.onSubscriberError;
    }
    publish(event) {
        const failures = [];
        const subscribers = [...(this.#subscribers.get(event.type) ?? [])];
        for (const subscriber of subscribers) {
            try {
                subscriber(event);
            }
            catch (error) {
                const failure = { error, event };
                failures.push(failure);
                this.#reportSubscriberError(failure);
            }
        }
        return failures;
    }
    publishDurable(sequence, event) {
        if (!Number.isSafeInteger(sequence) || sequence <= 0) {
            throw new TypeError("Durable event sequence must be a positive safe integer");
        }
        if (this.#durableSequences.has(sequence))
            return [];
        this.#durableSequences.add(sequence);
        return this.publish(event);
    }
    resetDurableSequenceTracking() {
        this.#durableSequences.clear();
    }
    subscribe(type, subscriber) {
        const subscribers = this.#subscribers.get(type) ?? [];
        const storedSubscriber = subscriber;
        subscribers.push(storedSubscriber);
        this.#subscribers.set(type, subscribers);
        return () => {
            const activeSubscribers = this.#subscribers.get(type);
            if (activeSubscribers === undefined)
                return;
            const index = activeSubscribers.indexOf(storedSubscriber);
            if (index === -1)
                return;
            activeSubscribers.splice(index, 1);
            if (activeSubscribers.length === 0)
                this.#subscribers.delete(type);
        };
    }
    #reportSubscriberError(failure) {
        try {
            this.#onSubscriberError?.(failure);
        }
        catch {
            // Error reporting must not suppress later synchronous subscribers.
        }
    }
}
//# sourceMappingURL=event-bus.js.map